/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement').offsetHeight + 'px');
// document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');
(function () {
  window.onpageshow = function() {
    if (window.theme.showPageTransition) {
      var pageTransition = document.querySelector('.PageTransition');

      if (pageTransition) {
        pageTransition.style.visibility = 'visible';
        pageTransition.style.opacity = '0';
      }
    }

    // When the page is loaded from the cache, we have to reload the cart content
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  };
})();

renderBadge = function(averageRating, reviewCount, badgePlaceholder, productHandle) {
  var $badge;
  $badge = $(badgePlaceholder);
  $badge.text('rating of ' + averageRating + ' from ' + reviewCount + ' reviews');
};

document.addEventListener('DOMContentLoaded', function(){
  var data;
  data = $.map($('.jdgm-badge-placeholder'), function(element) {
    var hash = {};
    var $element = $(element);
    hash['productHandle'] = $element.data('handle');
    hash['badgePlaceholder'] ='.jdgm-badge-placeholder[data-handle="' + $element.data('handle') + '"]';
    return hash;
  });
  // wait for a bit to make sure out js is loaded
  setTimeout( function(){
    jdgm.batchRenderBadgesWithCallback(data, renderBadge);
  }, 500);
});